module.exports = __webpack_public_path__ + "img/1fd8748177a2b8ded90de7ec7f3d51bf.svg";